"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _CoreProps = require("../utilities/CoreProps");
var _Title = _interopRequireDefault(require("./Title"));
var _SubTitle = _interopRequireDefault(require("./SubTitle"));
var _Level = _interopRequireDefault(require("../layout/Level"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Box = _ref => {
  let {
    title,
    subTitle,
    children,
    className,
    hasBackground,
    hasBorder,
    hasBorderTop,
    borderTopColor,
    customBackgroundClassName,
    hasRoundedCorners,
    renderAs,
    titleSize,
    titleUppercase,
    titleBold,
    titleColor,
    titleAlign,
    subTitleSize,
    subTitleUppercase,
    subTitleBold,
    subTitleColor,
    rightTitle,
    isTile
  } = _ref;
  const RenderAs = renderAs;
  const tileClassNames = (0, _classnames.default)({
    'tile is-child': isTile
  });
  const classNames = (0, _classnames.default)({
    'with-border': hasBorder,
    'with-border-top': hasBorderTop || borderTopColor,
    [`has-border-top-${borderTopColor}`]: borderTopColor,
    'with-no-border-radius': !hasRoundedCorners,
    'with-background': hasBackground,
    'tile is-child': isTile,
    [customBackgroundClassName]: customBackgroundClassName
  });
  const titleContent = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, title && /*#__PURE__*/_react.default.createElement(_Title.default, {
    size: titleSize,
    titleUppercase: titleUppercase,
    titleBold: titleBold,
    textColor: titleColor,
    right: titleAlign === 'right',
    centered: titleAlign === 'centered'
  }, title), subTitle && /*#__PURE__*/_react.default.createElement(_SubTitle.default, {
    size: subTitleSize,
    titleUppercase: subTitleUppercase,
    titleBold: subTitleBold,
    textColor: subTitleColor
  }, subTitle));
  const wrappedTitleContent = rightTitle && title && subTitle ? /*#__PURE__*/_react.default.createElement("div", null, titleContent) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, titleContent);
  return /*#__PURE__*/_react.default.createElement(RenderAs, {
    className: (0, _classnames.default)(tileClassNames, 'box', className, classNames) || undefined
  }, !rightTitle && titleContent, rightTitle && /*#__PURE__*/_react.default.createElement(_Level.default, {
    levelLeft: title || subTitle ? wrappedTitleContent : undefined,
    levelRight: rightTitle
  }), children);
};
Box.propTypes = {
  title: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string]),
  subTitle: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string]),
  rightTitle: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string]),
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string]).isRequired,
  className: _propTypes.default.string,
  customBackgroundClassName: _propTypes.default.string,
  hasBackground: _propTypes.default.bool,
  hasBorder: _propTypes.default.bool,
  hasRoundedCorners: _propTypes.default.bool,
  hasBorderTop: _propTypes.default.bool,
  titleSize: _propTypes.default.number,
  titleUppercase: _propTypes.default.bool,
  titleBold: _propTypes.default.bool,
  titleColor: _propTypes.default.oneOfType([_propTypes.default.oneOf(['primary', 'link', 'info', 'success', 'warning', 'danger', 'dark', 'text']), _propTypes.default.string]),
  borderTopColor: _propTypes.default.oneOfType([_propTypes.default.oneOf(['primary', 'link', 'info', 'success', 'warning', 'danger', 'dark', 'text', 'secondary', 'cyan', 'blue', 'sky', 'grape', 'teal', 'green', 'berry', 'rose', 'blue-light', 'sky-light', 'grape-light', 'teal-light', 'green-light', 'berry-light', 'rose-light', 'blue-dark', 'sky-dark', 'grape-dark', 'teal-dark', 'green-dark', 'berry-dark', 'rose-dark']), _propTypes.default.string]),
  titleAlign: _propTypes.default.oneOfType([_propTypes.default.oneOf(['default', 'left', 'right', 'center']), _propTypes.default.string]),
  subTitleSize: _propTypes.default.number,
  subTitleUppercase: _propTypes.default.bool,
  subTitleBold: _propTypes.default.bool,
  subTitleColor: _propTypes.default.oneOfType([_propTypes.default.oneOf(['primary', 'link', 'info', 'success', 'warning', 'danger', 'dark', 'text']), _propTypes.default.string]),
  isTile: _propTypes.default.bool,
  renderAs: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.string, _propTypes.default.object])
};
Box.defaultProps = {
  hasBackground: false,
  title: '',
  hasRoundedCorners: false,
  hasBorder: false,
  hasBorderTop: false,
  titleSize: 2,
  subTitleSize: 4,
  titleUppercase: true,
  titleBold: true,
  renderAs: 'div'
};
var _default = exports.default = (0, _CoreProps.withUiProps)(Box);
//# sourceMappingURL=Box.js.map